import React, { FC, useState } from "react";

import { redirectToAirflowGraphUrl } from "api/ScheduledTasksApi";
import Search from "components/basic/search/Search";
import airflowLogo from "img/airflow-icon16.png";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { useSearchParams } from "react-router-dom";
import { T } from "services/lang/LanguageService";
import { AirflowDag } from "types/airflow";
import AirflowDagForm from "./AirflowDagForm";
import AirflowTaskForm from "./AirflowTaskForm";

type DagHeaderProps = {
  dag: AirflowDag;
};
const DagHeader: FC<DagHeaderProps> = ({ dag }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [createTaskDialog, setCreateTaskDialog] = useState(false);
  const [editDagDialog, setEditDagDialog] = useState(false);

  const search = searchParams.get("search") || "";
  return (
    <div className="flex justify-content-between px-3 py-2">
      <div className="flex gap-2">
        <Button
          label={T("action.create-task")}
          icon="pi pi-plus"
          className="dashboard-editor-button icon-green border-green"
          onClick={() => setCreateTaskDialog(true)}
        />
        <Button
          label={`${T("action.edit")} DAG`}
          icon="pi pi-pencil"
          className="dashboard-editor-button icon-orange border-orange"
          onClick={() => setEditDagDialog(true)}
        />
      </div>
      <Search
        value={search}
        onChange={val => setSearchParams({ search: val })}
        placeholder={T("action.search-for-tasks")}
      />
      <div>
        <a href={redirectToAirflowGraphUrl(dag?.dagId)} target="_blank" rel="noreferrer">
          <Button
            label={`Airflow DAG ${T("word.graph")}`}
            type="button"
            icon={<img src={airflowLogo} alt="" className="mr-2" />}
            className="dashboard-editor-button border-black"
            severity="contrast"
          />
        </a>
      </div>
      <Dialog
        visible={createTaskDialog}
        header="Create new task"
        onHide={() => setCreateTaskDialog(false)}
        style={{ width: "min(100%, 700px)" }}
      >
        <AirflowTaskForm closeDialog={() => setCreateTaskDialog(false)} dag={dag} />
      </Dialog>

      <Dialog
        visible={editDagDialog}
        header="Edit DAG"
        onHide={() => setEditDagDialog(false)}
        style={{ width: "min(100%, 700px)" }}
      >
        <AirflowDagForm closeDialog={() => setEditDagDialog(false)} dag={dag} />
      </Dialog>
    </div>
  );
};

export default DagHeader;
